<virtual-scroller fxFlex #virtualScroller (vsEnd)="onVirtualScrollerEndEvent($event)" [items]="listOfTechnicalDatasheets">
  <div
    class="technical-datasheet-container"
    *ngFor="let technicalDatasheet of virtualScroller.viewPortItems"
    fxLayout="column"
    fxLayoutAlign="start center"
    fxLayoutGap="8px"
    (click)="selectTechnicalDatasheet(technicalDatasheet)"
    [class.selected]="isTechnicalDatasheetSelected(technicalDatasheet)"
  >
    <div class="technical-datasheet" (mouseenter)="ellipsisLabel.ellipsisTooltip.show()" (mouseleave)="ellipsisLabel.ellipsisTooltip.hide()">
      <app-technical-datasheet-image-preview [technicalDatasheetId]="technicalDatasheet.id" [shouldDownloadImage]="true"> </app-technical-datasheet-image-preview>

      <app-thumbnail-selected-indicator *ngIf="isTechnicalDatasheetSelected(technicalDatasheet)"></app-thumbnail-selected-indicator>
    </div>

    <div class="b1 technical-datasheet-name full-width" fxLayout="row" fxLayoutAlign="center">
      <vdw-ellipsis-label appDataCy="technical-datasheet-name" #ellipsisLabel [text]="technicalDatasheet.name" matTooltipPosition="above" fxFlex></vdw-ellipsis-label>
    </div>
  </div>
</virtual-scroller>
